import { useMicdropState } from '@micdrop/react';

import StatusCircle from '@/components/organisms/StatusCircle.tsx';

import { useInterviewFlowContext } from '../contexts/interview-flow.context';

interface Props {
  size: number;
}

export default function CallStatusCircle({ size }: Props) {
  const { isCVGenerating } = useInterviewFlowContext();
  const micdropState = useMicdropState();

  return <StatusCircle size={size} isCVGenerating={isCVGenerating} micdropState={micdropState} />;
}
